import { render, staticRenderFns } from "./ElmcoMachine.vue?vue&type=template&id=572748e6&scoped=true"
import script from "./ElmcoMachine.vue?vue&type=script&lang=js"
export * from "./ElmcoMachine.vue?vue&type=script&lang=js"
import style0 from "./ElmcoMachine.vue?vue&type=style&index=0&id=572748e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572748e6",
  null
  
)

export default component.exports